export type VacancyId = 'chat-operator' | 'hr-manager' | 'smm-manager' | 'quality-manager';

export type AccentColor = 'emerald' | 'amber' | 'sky' | 'violet';

export interface VacancyDef {
  id: VacancyId;
  title: string;
  description: string;
  icon: string;
  accent: AccentColor;
  route: string;
  badge?: string;
  /** Надпись на кнопке. У HR она исторически другая — менять нельзя. */
  buttonLabel: string;
}

export const VACANCY_REGISTRY: Record<VacancyId, VacancyDef> = {
  'hr-manager': {
    id: 'hr-manager',
    title: 'HR Менеджер',
    description:
      'Выгрузка и обработка откликов, управление собственными верификациями, согласование объявлений.',
    icon: 'ri-user-star-line',
    accent: 'amber',
    route: '/hr-manager',
    buttonLabel: 'Войти как HR менеджер',
  },
  'chat-operator': {
    id: 'chat-operator',
    title: 'Оператор чата',
    description:
      'Поддержка клиентов в онлайн-чате, решение вопросов, обработка обращений и консультации.',
    icon: 'ri-message-3-line',
    accent: 'emerald',
    route: '/chat-operator',
    badge: 'Активно',
    buttonLabel: 'Войти в кабинет',
  },
  'quality-manager': {
    id: 'quality-manager',
    title: 'Менеджер оценки качества',
    description:
      'Оценка качества обслуживания, проверка диалогов операторов, формирование отчётов по стандартам.',
    icon: 'ri-shield-check-line',
    accent: 'violet',
    route: '/quality-manager',
    buttonLabel: 'Войти в кабинет',
  },
  'smm-manager': {
    id: 'smm-manager',
    title: 'Менеджер социальных сетей',
    description:
      'Ведение социальных сетей, работа с комментариями и сообщениями, коммуникация с аудиторией.',
    icon: 'ri-share-forward-line',
    accent: 'sky',
    route: '/smm-manager',
    badge: 'Активно',
    buttonLabel: 'Войти в кабинет',
  },
};

export const ACCENT_CLASSES: Record<AccentColor, {
  border: string; borderHover: string; iconText: string;
  gradient: string; badge: string; button: string;
}> = {
  emerald: {
    border: 'border-primary-500/30', borderHover: 'hover:border-primary-500/60',
    iconText: 'text-primary-300',
    gradient: 'linear-gradient(135deg, #5348e820, #5348e840)',
    badge: 'text-primary-300 bg-primary-500/10 border-primary-500/20',
    button: 'bg-primary-600 hover:bg-primary-500 text-white font-semibold',
  },
  amber: {
    border: 'border-[#18181c]', borderHover: 'hover:border-accent-300/40',
    iconText: 'text-accent-200',
    gradient: 'linear-gradient(135deg, #f0cbaa20, #f0cbaa40)',
    badge: 'text-accent-200 bg-accent-300/10 border-accent-300/20',
    button: 'border border-[#26262c] hover:border-accent-300/50 text-foreground-700 hover:text-white font-medium',
  },
  sky: {
    border: 'border-sky-500/30', borderHover: 'hover:border-sky-500/60',
    iconText: 'text-sky-400',
    gradient: 'linear-gradient(135deg, #0ea5e920, #0ea5e940)',
    badge: 'text-sky-400 bg-sky-500/10 border-sky-500/20',
    button: 'bg-sky-500 hover:bg-sky-400 text-white font-semibold',
  },
  violet: {
    border: 'border-[#18181c]', borderHover: 'hover:border-violet-500/40',
    iconText: 'text-violet-400',
    gradient: 'linear-gradient(135deg, #8b5cf620, #8b5cf640)',
    badge: 'text-violet-400 bg-violet-500/10 border-violet-500/20',
    button: 'border border-[#26262c] hover:border-violet-500/50 text-foreground-700 hover:text-white font-medium',
  },
};
